type Props = {
  className?: string
}

export const LoadingSpinner = ({ className }: Props) => {
  return (
    <div className={className}>
      <img className="animate-spin" src="/images/loading-spinner.svg" alt="loading" />
    </div>
  )
}
